<template >
  <div class="lead-info-card" v-if="lead">
    <div v-if="!editing">
      <div class="row">
        <div class="custom_button_rounded clickable" @click="handleEditClicked" v-if="canEdit">
          <i class="fa fa-pencil is-bold"/>
          <span>&ensp;{{ $t('leads-web.leads.edit') }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('leads-web.leads.name') }}</span>
          <p class="label-text">{{lead.name || "N/A"}}</p>
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('leads-web.leads.email') }}</span>
          <p class="label-text">{{lead.email || "N/A"}}</p>
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('leads-web.leads.phone') }}</span>
          <p class="label-text">{{lead.phone || "N/A"}}</p>
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('leads-web.leads.birthdate') }}</span>
          <p class="label-text">{{lead.birthdate || "N/A"}}</p>
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('leads-web.leads.postal-code') }}</span>
          <p class="label-text">{{lead.postalCode || "N/A"}} </p>
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('leads-web.leads.address') }}</span>
          <p class="label-text">{{lead.city || "N/A"}} </p>
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('leads-web.leads.country') }}</span>
          <p class="label-text">{{lead.country || "N/A"}} </p>
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('leads-web.leads.language') }}</span>
          <p class="label-text">{{lead.language || "N/A"}} </p>
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('leads-web.leads.campaign') }}</span>
          <p class="label-text">{{lead.campaign || "N/A"}} </p>
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('leads-web.leads.client_entity') }}</span>
          <p class="label-text">{{ handleClientEntity(lead) }} </p>
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('leads-web.leads.entry_source') }}</span>
          <p class="label-text">{{lead.source || "N/A"}} </p>
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('leads-web.leads.lead_supplier') }}</span>
          <p class="label-text">{{lead.supplier ? lead.supplier.name : "N/A"}} </p>
        </div>
      </div>
    </div>
    <div v-if="editing" class="evollu-form">
      <div class="form-row">
        <div class="col-12 col-md-6 mb-3">
          <va-input
            id="lead-name"
            :label="$t('leads-web.leads.name')"
            v-model="form.data.name"
            :placeholder="$t('leads-web.leads.name')"
            @input="form.errors.clear('name')"
            :error="form.errors.has('name')"
            :error-messages="[$t(form.errors.get('name'))]"
          />
        </div>

        <div class="col-12 col-md-6 mb-3">
          <va-input
            id="lead-email"
            :label="$t('leads-web.leads.email')"
            v-model="form.data.email"
            :placeholder="$t('leads-web.leads.email')"
            @input="form.errors.clear('email')"
            :error="form.errors.has('email')"
            :error-messages="[$t(form.errors.get('email'))]"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="col-12 col-md-6 mb-3">
          <label  class="form-label">{{$t('leads-web.leads.phone')}}</label>
        <vue-tel-input
          inputId="lead-phone"
          style="width: inherit;"
          :key="vueTelInputRedrawIndex"
          v-model="form.data.phone"
          maxlength="20"
          :preferredCountries="countries.allowed"
          :disabledFetchingCountry="true"
          :defaultCountry="defaultCountrySelection"
          :placeholder="$t('people.inputs.phone')"
          @validate="mobilePhoneValidation">
        </vue-tel-input>
        <span class="small text-danger" v-show="form.data.phone !== '' && form.data.phone !== null && invalidMobilePhone">
          {{ $t('patients.errors.invalidPhone') }}
        </span>
        </div>

        <div class="col-12 col-md-6 mb-3">

            <div
              class="form-group"
              :class="{
                  'has-error': form.errors.has('birthdate')}"
            >
              <div class="input-group">
                <DatePicker
                  :label="$t('leads-web.leads.birthdate')"
                  id="lead-birthdate"
                  class="w-100"
                  v-model="form.data.birthdate"
                  :config="datePickerConfig"
                  :placeholder="$t('agenda.availability.start')"
                  :error="form.errors.has('birthdate')"
                  :error-messages="[$t(form.errors.get('birthdate'))]"
                  @input="form.errors.clear('birthdate')" />
              </div>
            </div>
          <!--<va-input
            id="lead-birthdate"
            :label="$t('leads-web.leads.birthdate')"
            v-model="form.data.birthdate"
            :placeholder="$t('leads-web.leads.birthdate')"
            @input="form.errors.clear('birthdate')"
            :error="form.errors.has('birthdate')"
            :error-messages="[$t(form.errors.get('birthdate'))]"
          />-->
        </div>
      </div>

      <div class="form-row">
        <div class="col-12 col-md-6 mb-3">
          <va-input
            id="lead-postal"
            :label="$t('leads-web.leads.postal-code')"
            v-model="form.data.postalCode"
            :placeholder="$t('leads-web.leads.postal-code')"
            @input="form.errors.clear('postalCode')"
            :error="form.errors.has('postalCode')"
            :error-messages="[$t(form.errors.get('postalCode'))]"
          />
        </div>

        <div class="col-12 col-md-6 mb-3">
          <va-input
            id="lead-city"
            :label="$t('leads-web.leads.address')"
            v-model="form.data.city"
            :placeholder="$t('leads-web.leads.address')"
            @input="form.errors.clear('city')"
            :error="form.errors.has('city')"
            :error-messages="[$t(form.errors.get('city'))]"
          />
        </div>
      </div>

      <div class="form-row">
        <div class="col-12 col-md-6 mb-3">
          <va-input
            id="lead-country"
            :label="$t('leads-web.leads.country')"
            v-model="form.data.country"
            :placeholder="$t('leads-web.leads.country')"
            @input="form.errors.clear('country')"
            :error="form.errors.has('country')"
            :error-messages="[$t(form.errors.get('country'))]"
          />
        </div>

        <div class="col-12 col-md-6 mb-3">
          <va-input
            :maxlength="2"
            id="lead-language"
            :label="$t('leads-web.leads.language')"
            v-model="form.data.language"
            :placeholder="$t('leads-web.leads.language')"
            @input="form.errors.clear('language')"
            :error="form.errors.has('language')"
            :error-messages="[$t(form.errors.get('language'))]"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="col-12 col-md-6 mb-3">
          <va-input
            id="lead-campaign"
            :label="$t('leads-web.leads.campaign')"
            v-model="form.data.campaign"
            :placeholder="$t('leads-web.leads.campaign')"
            @input="form.errors.clear('campaign')"
            :error="form.errors.has('campaign')"
            :error-messages="[$t(form.errors.get('campaign'))]"
          />
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label class="form-label" :class="{'text-danger': form.errors.has('clientId')}">
            {{ $t('leads-web.leads.client_entity') }}
          </label>
          <multiselect
            id="lead-entity"
            v-model="selectedEntity"
            :options="writableEntities"
            track-by="id"
            label="name"
            placeholder="---"
            :allow-empty="false"
            :multiple="false"
            @input="form.errors.clear('clientId')"
          >
            <template slot="clear">
                  <span class="multiselect__clear" v-if="selectedEntity"
                        @mousedown.prevent.stop="selectedEntity = null"></span>
            </template>
          </multiselect>
          <div class="text-danger" v-if="form.errors.has('clientId')">
            <small>{{ $t(form.errors.get('clientId')) }}</small>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12 col-md-6 mb-3">
          <va-input
            id="lead-source"
            :label="$t('leads-web.leads.entry_source')"
            v-model="form.data.source"
            :placeholder="$t('leads-web.leads.entry_source')"
            @input="form.errors.clear('source')"
            :error="form.errors.has('source')"
            :error-messages="[$t(form.errors.get('source'))]"
          />
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label class="form-label" :class="{'text-danger': form.errors.has('supplier')}">
            {{ $t('leads-web.leads.lead_supplier') }}
          </label>
          <multiselect
            id="lead-supplier"
            v-model="selectedSupplier"
            :options="suppliers"
            track-by="id"
            label="name"
            placeholder="---"
            :allow-empty="false"
            :multiple="false"
            @input="form.errors.clear('supplier')"
          >
            <template slot="clear">
                  <span class="multiselect__clear" v-if="selectedSupplier"
                        @mousedown.prevent.stop="selectedSupplier = null"></span>
            </template>
          </multiselect>
          <div class="text-danger" v-if="form.errors.has('supplier')">
            <small>{{ $t(form.errors.get('supplier')) }}</small>
          </div>
        </div>

        </div>
      </div>

    </div>
</template>

<script>
import Errors from '@/utils/StandardErrors.js'
import Multiselect from 'vue-multiselect'
import { LeadsWebService } from '@/api/LeadsWebService'
import { mapState } from 'vuex'
import { VueTelInput } from 'vue-tel-input'
import DatePicker from '@/components/common/DatePicker'
import moment from 'moment'
const LEADS_WEB_INFO_TYPE = 3000
export default {
  props: {
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    writableEntities: {
      type: Array,
      required: true
    },
    readEntities: {
      type: Array,
      required: true
    },
    lead: {
      type: Object,
      required: true
    },
    suppliers: {
      type: Array,
      required: true
    },
  },
  components: {
    DatePicker,
    VueTelInput,
    Multiselect,
  },
  mixins: [
  ],
  data () {
    return {
      editing: false,
      vueTelInputRedrawIndex: 0,
      selectedEntity: null,
      selectedSupplier: null,
      originalData: {},
      form: {
        data: {
          name: null,
          email: null,
          phone: null,
          birthdate: null,
          postalCode: null,
          city: null,
          country: null,
          language: null,
          campaign: null,
          clientId: null,
          source: null,
          supplier: null
        },
        errors: new Errors()
      },
      invalidMobilePhone: false,
    }
  },
  mounted () {
    if (this.writableEntities.length === 1) {
      this.selectedEntity = this.writableEntities[0]
    }
  },
  methods: {
    mobilePhoneValidation: function (data) {
      this.invalidMobilePhone = !data.isValid
      if (data.isValid) {
        this.form.data.phone = data.number.international.trim()
      }
    },
    handleClientEntity (lead) {
      if (lead.clientId && this.readEntities.length) {
        return this.readEntities.find(entity => entity.id === lead.clientId).name
      }
      return 'N/A'
    },
    handleEditClicked () {
      this.editing = true
      this.$emit('editing-lead')
      this.prepareForUpdate()
    },
    prepareForUpdate: function () {
      let data = JSON.parse(JSON.stringify(this.lead))

      this.selectedEntity = data.clientId ? this.writableEntities.find(entity => entity.id === data.clientId) : null
      this.selectedSupplier = data.supplier ? this.suppliers.find(sup => sup.id === data.supplier.id) : null

      Object.keys(data).filter(key => key in this.form.data).forEach(key => {
        this.form.data[key] = data[key]
      })
      this.originalData = { ...this.form.data }
    },
    validateForm: function () {
      let isValid = true

      if (this.form.data.clientId === null) {
        this.form.errors.set('clientId', 'leads-web.errors.client_id_is_required')
        isValid = false
      }

      if (this.form.data.supplier === null) {
        this.form.errors.set('supplier', 'leads-web.errors.supplier_is_required')
        isValid = false
      }

      if (!isValid) {
        this.showToast(this.$t('leads-web.errors.form_contains_errors'), this.$store.state.errorToastOptions)
      }

      if (this.form.data.email === '') {
        this.form.data.email = null
      }

      return isValid
    },
    updateLead () {
      if (this.isLoading) {
        return
      }

      if (!this.validateForm()) {
        return
      }
      this.isLoading = true

      LeadsWebService.update(this.lead.id, this.form.data).then(lead => {
        this.showToast(this.$t('leads-web.leads.update_success'), this.$store.state.successToastOptions)
        this.$emit('lead-updated', lead)
        this.editing = false
      })
        .catch(errors => {
          let message = null
          if (errors.response.status === 422) {
            message = this.$t('leads-web.errors.form_contains_errors')
            this.form.errors.record(errors.response.data.errors, 'leads-web.errors.')
          } else {
            message = this.$t('leads-web.leads.update_error')
          }
          this.showToast(message, this.$store.state.errorToastOptions)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  computed: {
    ...mapState({
      'countries': (state) => state.countries,
      'leadsWebToken': (state) => state.leadsWeb.leadsWebSrvToken
    }),
    datePickerConfig: function () {
      return {
        enableTime: false,
        noCalendar: false,
        dateFormat: 'Y-m-d',
        maxDate: 'today'
      }
    },
    audiologyService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollead_server)
    },
    defaultCountrySelection: function () {
      let clientEntity = this.canEdit ? this.writableEntities.find(entity => entity.id === this.form.clientId) : this.readEntities.find(entity => entity.id === this.form.clientId)
      if (clientEntity && this.countries.allowed.includes(clientEntity.country)) {
        return clientEntity.country
      }
      return this.$store.state.countries.default
    },
  },
  watch: {
    selectedEntity: function (newValue, oldValue) {
      this.form.data.clientId = newValue ? newValue.id : null
    },
    selectedSupplier: function (newValue, oldValue) {
      this.form.data.supplier = newValue ? this.suppliers.find(sup => sup.id === newValue.id) : null
    },
    'form.data': {
      handler (value) {
        this.$emit('can-submit', JSON.stringify(value) !== JSON.stringify(this.originalData))
      },
      deep: true
    }
  }
}
</script>
<style scoped lang="scss">
.custom_button_rounded {
  width: 12%;
  height: 30px;
  background-color: #6E6E6E;
  margin-left: auto;
  margin-right: 20px;
  color: white;
  padding: 2px 0;
  border-radius: 25px;
  text-align: center;
}

.lead-info-card {
  margin-bottom: 10px;
  padding: 10px;
  box-shadow: 0px 0px 12px #babfc2;
}

.label-text {
  color: #8c8c8c;
}
</style>
